import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { EoptionsService } from 'src/app/services/eoptions.service';

@Component({
    selector: 'app-option-ticker',
    templateUrl: './option-ticker.component.html',
    styleUrls: ['./option-ticker.component.css']
})
export class OptionTickerComponent implements OnInit {
    isDropdownOpen = false;
    selectedPair = 'BTCUSDT';
    availablePairs = ['BTCUSDT', 'ETHUSDT', 'BNBUSDT', 'XRPUSDT', 'SOLUSDT'];
    currentViewMode: 'TABLE' | 'CHART' = 'TABLE';

    constructor(
        private eoptionsService: EoptionsService,
        private elementRef: ElementRef
    ) { }

    ngOnInit(): void {
        this.eoptionsService.selectedPair$.subscribe(pair => {
            this.selectedPair = pair;
        });

        this.eoptionsService.viewMode$.subscribe(mode => {
            this.currentViewMode = mode;
        });

        this.fetchPairs();
    }

    setViewMode(mode: 'TABLE' | 'CHART') {
        this.eoptionsService.setViewMode(mode);
    }

    fetchPairs() {
        this.eoptionsService.getPairs().subscribe({
            next: (res: any) => {
                if (res.status && res.data && res.data.length > 0) {
                    // Basic logic: Map underlying to displayed pair name if needed
                    // The API returns distinct underlying e.g. ["BTC", "ETH"]
                    // We want "BTCUSDT", "ETHUSDT"
                    this.availablePairs = res.data.map((u: string) => u.includes('USDT') ? u : u + 'USDT');
                }
            },
            error: (err) => console.error(err)
        });
    }

    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    selectPair(pair: string) {
        this.eoptionsService.setPair(pair);
        this.isDropdownOpen = false;
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isDropdownOpen = false;
        }
    }
}
